import React, { FC } from 'react'

import { Colors } from 'common-constants/colors'

export const SharingContentSvg: FC<{
  size?: number
  stroke?: Colors
}> = ({ size = 24, stroke = Colors.white }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd" stroke={stroke} strokeWidth="1.5">
      <path d="M3 11.158v9.714h18v-9.714M12 16.782V5.023M7.737 8.602L12 4l4.263 4.602" />
    </g>
  </svg>
)
